import { render } from "./campaign.html?vue&type=template&id=ae0758b6&ts=true"
import script from "./campaign.vue?vue&type=script&lang=ts"
export * from "./campaign.vue?vue&type=script&lang=ts"

import "./campaign.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__